import pageLoader from "./common-components/pageLoader";
import selectTo from './common-components/selectTo';
import landscapeOff from "./common-components/landscapeOff";
import mobileMenu from './common-components/mobile-menu';
import StickyHeader from './components/sticky-header';
import HorizontalImageSection from './components/horizontal-image-section';
import IntelInput from './components/intel-input';
import ProjectList from './components/project-list';
import Carousel from './components/carousel';
import Tab from './components/tab';
import Accordion from './components/accordion';
import ProjectOverViewMarquee from './components/project-overview-marquee';
import Video from './components/video';
import AboutImageCard from "./components/about-image-card";
import VillasSlider from "./components/villas-slider";
import VideoLoader from "./common-components/video-loader";
import Stepper from "./components/stepper";


// Animations
import animateObserver from "./common-components/animateObserver";
import ZoomCircleAnimation from './components/zoom-circle-animation';
import RevealImageAnimation from './components/reveal-image-animation';
import OurBrandAnimation from './components/our-brand-animation';

// Init Animation observer
animateObserver();
// Init Landscape off
landscapeOff();
// Init Mobile menu
mobileMenu();
// Init Sticky Header
StickyHeader();
// Init Horizontal Image Section
HorizontalImageSection();
// Init Contact form
IntelInput();
// Init Project List
ProjectList();
// Init Tab
Tab();
// Init Accordion
Accordion();
// Zoom Circle animation init
ZoomCircleAnimation();
// Project Overview animation
ProjectOverViewMarquee();
// About image card
AboutImageCard();
// Init Stepper
Stepper();
// Init Service carousel
Carousel('.serviceCarousel', {
    slidesPerView: 1,
    spaceBetween: 20,
    pagination: {
        el: ".services-pagination",
        clickable: true,
    },
    navigation: {
        nextEl: ".services-button-prev",
        prevEl: ".services-button-next",
    },
    breakpoints: {
        640: {
            slidesPerView: 1,
            spaceBetween: 20,
        },
        768: {
            slidesPerView: 2.2,
            spaceBetween: 15,
        },
        1024: {
            slidesPerView: 3.2,
            spaceBetween: 15,
        },
        1025: {
            slidesPerView: 4,
            spaceBetween: 30,
        },
    },
    on: {
        init: (e) => {
            // Get per view slides
            const perView = e.slidesPerViewDynamic();
            // Getting current active slide
            const current = e.realIndex + perView;
            // Getting total slides
            const total = e.slides.length;
            // Get the progress element
            const element = document.querySelector('.serviceCarousel .bar');
            // Setting progress
            element.style.width = (current/total * 100)+"%";
        },
        slideChange: (e) => {
            // Get per view slides
            const perView = e.slidesPerViewDynamic();
            // Getting current active slide
            const current = e.realIndex + perView;
            // Getting total slides
            const total = e.slides.length;
            // Get the progress element
            const element = document.querySelector('.serviceCarousel .bar');
            // Setting progress
            element.style.width = (current/total * 100)+"%";
        }
    }
});
// Init Owner carousel
Carousel('.ownerSlider', {
    slidesPerView: 1,
    spaceBetween: 0,
    pagination: {
        el: ".owner-pagination",
        clickable: true,
    },
    navigation: {
        nextEl: ".owner-button-prev",
        prevEl: ".owner-button-next",
    },
    breakpoints: {
        640: {
            slidesPerView: 1,
            spaceBetween: 0,
        },
        768: {
            slidesPerView: 2.2,
            spaceBetween: 15,
        },
        1024: {
            slidesPerView: 3,
            spaceBetween: 15,
        },
        1025: {
            slidesPerView: 3,
            spaceBetween: 30,
        },
    },
    on: {
        init: (e) => {
            // Get per view slides
            const perView = e.slidesPerViewDynamic();
            // Getting current active slide
            const current = e.realIndex + perView;
            // Getting total slides
            const total = e.slides.length;
            // Get the progress element
            const element = document.querySelector('.ownerSlider .bar');
            // Setting progress
            element.style.width = (current/total * 100)+"%";
        },
        slideChange: (e) => {
            // Get per view slides
            const perView = e.slidesPerViewDynamic();
            // Getting current active slide
            const current = e.realIndex + perView;
            // Getting total slides
            const total = e.slides.length;
            // Get the progress element
            const element = document.querySelector('.ownerSlider .bar');
            // Setting progress
            element.style.width = (current/total * 100)+"%";
        }
    }
});
// Init Apartment carousel
Carousel('.apartmentSlider', {
    slidesPerView: 1,
    spaceBetween: 0,
    noSwiping: true,
    allowTouchMove: false,
    autoplay: true,
    speed: 1500,
    pagination: {
        el: ".apartment-pagination",
        clickable: true,
    },
});
// Init amenities carousel
Carousel('.amenitiesSlider', {
    slidesPerView: 1,
    spaceBetween: 20,
    pagination: {
        el: ".amenities-pagination",
        clickable: true,
    },
    navigation: {
        nextEl: ".amenities-button-next",
        prevEl: ".amenities-button-prev",
    },
    breakpoints: {
        640: {
            slidesPerView: 1,
            spaceBetween: 20,
        },
        768: {
            slidesPerView: 2.2,
            spaceBetween: 15,
        },
        1024: {
            slidesPerView: 3.2,
            spaceBetween: 15,
        },
        1025: {
            slidesPerView: 4,
            spaceBetween: 30,
        },
    },
});
// Init Showcase Small Slider carousel
const showcaseSliderController = Carousel('.showcaseSmallSlider', {
    slidesPerView: 1,
    spaceBetween: 0,
    noSwiping: false,
    allowTouchMove: true,
    watchSlidesProgress: true,
    autoplay: true,
    loop: true,
    speed: 300,
    thumbs: {
        swiper: '.showcaseThumbs',
    },
    pagination: {
        el: ".showcaseSmall-pagination",
        clickable: true,
    },
    navigation: {
        nextEl: ".showcaseSmall-button-prev",
        prevEl: ".showcaseSmall-button-next",
    },
    breakpoints: {
        1025: {
            speed: 1500,
            noSwiping: true,
            allowTouchMove: false,
        },
    },
});
// Init Showcase Background Slider carousel
const showcaseBigImageSlider = Carousel('.showcaseBigImageSlider', {
    slidesPerView: 1,
    spaceBetween: 0,
    noSwiping: true,
    allowTouchMove: false,
    loop: true,
    pagination: {
        el: ".sliderCounter",
        type: 'custom',
        clickable: true,
        renderCustom: function (swiper, current, total) {
            function numberAppend(d) {
                return (d < 10) ? '0' + d.toString() : d.toString();
            }
            return numberAppend(current) + ' / ' + numberAppend(total);
        }
    },
});
// Init Showcase Small Slider carousel
Carousel('.showcaseThumbs', {
    slidesPerView: 2,
    spaceBetween: 40,
    noSwiping: true,
    allowTouchMove: false,
    loop: true,
    breakpoints: {
        768: {
            slidesPerView: 2,
            spaceBetween: 15,
        },
        1025: {
            slidesPerView: 3,
            spaceBetween: 40,
        },
    },
});
// Showcase slider controller setup
showcaseSliderController.controller.control = [showcaseBigImageSlider];
// Init Reveal Image animation
RevealImageAnimation();
// Init Video
Video();
// Init Our Brand Animation
OurBrandAnimation();
// Init villas slider
VillasSlider();
// Init video loader
VideoLoader();
// Init Villas carousel
Carousel('.villaSlider', {
    slidesPerView: 1,
    spaceBetween: 20,
    pagination: {
        el: ".villas-pagination",
        clickable: true,
    },
    navigation: {
        nextEl: ".villas-button-next",
        prevEl: ".villas-button-prev",
    },
    breakpoints: {
        640: {
            slidesPerView: 1,
            spaceBetween: 20,
        },
        768: {
            slidesPerView: 2.2,
            spaceBetween: 15,
        },
        1024: {
            slidesPerView: 3.2,
            spaceBetween: 15,
        },
        1025: {
            slidesPerView: 3.5,
            spaceBetween: 30,
        },
    },
});


// Init Testimonials carousel
Carousel('.testimonialPicSlider', {
    slidesPerView: 1,
    watchSlidesProgress: true,  
    noSwiping: true,
    allowTouchMove: false,
    effect: 'fade',
    speed: 1000
});
// Init Testimonials carousel
Carousel('.testimonialTxtSlider', {
    slidesPerView: 1,
    spaceBetween: 0,
    watchSlidesProgress: true,
    noSwiping: true,
    allowTouchMove: false,
    thumbs: {
        swiper: '.testimonialPicSlider',
    },
    pagination: {
        el: ".testimonial-pagination",
        clickable: true,
    },
    navigation: {
        nextEl: ".testimonial-button-next",
        prevEl: ".testimonial-button-prev",
    }
});